import React from "react";
import StatusBadge from "../ui/StatusBadge";
import {
  getCalculatieCloneTypeLabel,
  formatDateTime,
  getCalculatieClientName,
  getCalculatieSeriesCode,
  getCalculatieDocumentNumber,
  getCalculatieOpnameTitle,
  getClientName,
  getClientNumber,
  getProjectName,
  getProjectNumber,
  getSourceTypeLabel,
} from "./utils";

export default function CalculatieHeader({
  form,
  editingId,
  selectedClient,
  selectedOpname,
  selectedProject,
  selectedCalculatie,
  children,
}) {
  const documentNumber = getCalculatieDocumentNumber(selectedCalculatie, editingId);
  const clientNumber = getClientNumber(selectedClient);
  const clientName = getClientName(selectedClient);
  const fallbackClientName = getCalculatieClientName(selectedCalculatie || {});
  const opnameTitle = selectedOpname?.titel || selectedOpname?.title || getCalculatieOpnameTitle(selectedCalculatie || {});
  const projectNumber = getProjectNumber(selectedProject);
  const projectName = getProjectName(selectedProject);
  const cloneTypeLabel = getCalculatieCloneTypeLabel(selectedCalculatie?.cloneType);
  const seriesCode = getCalculatieSeriesCode(selectedCalculatie || {});
  const derivedFromLabel = selectedCalculatie?.derivedFromCalculatieId
    ? getCalculatieDocumentNumber(selectedCalculatie.derivedFromCalculatieId)
    : "";
  const primaryContextLabel = clientName && clientName !== "-"
    ? `${clientNumber && clientNumber !== "-" ? `${clientNumber} · ` : ""}${clientName}`
    : fallbackClientName && fallbackClientName !== "-"
      ? fallbackClientName
      : "Nog geen relatie/context gekoppeld";

  return (
    <header className="sticky top-0 z-20 border border-slate-200 bg-white/95 px-4 py-3 shadow-sm backdrop-blur">
      <div className="flex flex-col gap-4 xl:flex-row xl:items-start xl:justify-between">
        <div className="min-w-0 space-y-3">
          <div className="flex flex-wrap items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">
            <span>{documentNumber}</span>
            <span className="text-slate-300">/</span>
            <span>Calculatiewerkplek</span>
          </div>

          <div className="space-y-1">
            <h2 className="truncate text-2xl font-semibold tracking-tight text-slate-950">
              {String(form.title || "").trim() || "Nieuwe calculatie"}
            </h2>
            <p className="text-sm text-slate-600">
              {primaryContextLabel}
              {opnameTitle && opnameTitle !== "-" ? ` · ${opnameTitle}` : ""}
              {selectedProject ? ` · ${projectNumber} · ${projectName}` : ""}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 text-sm text-slate-600">
            <StatusBadge status={form.status} label={capitalize(form.status || "concept")} />
            <span className="rounded-sm border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
              {getSourceTypeLabel(form.sourceType || selectedCalculatie?.sourceType)}
            </span>
            <span className="rounded-sm border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
              Versie {form.version || "1"}
            </span>
            <span className="rounded-sm border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
              {cloneTypeLabel}
            </span>
            <span className="rounded-sm border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
              {seriesCode}
            </span>
            {derivedFromLabel ? (
              <span className="rounded-sm border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
                Afgeleid van {derivedFromLabel}
              </span>
            ) : null}
            <span className="rounded-sm border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-700">
              Laatst gewijzigd {formatDateTime(selectedCalculatie?.updatedAt)}
            </span>
          </div>
        </div>

        <div className="shrink-0">{children}</div>
      </div>
    </header>
  );
}

function capitalize(value) {
  const input = String(value || "").trim();
  if (!input) return "-";
  return input.charAt(0).toUpperCase() + input.slice(1);
}
